import React from 'react';
import { matchPath, useLocation } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Utils
import { getCurrentMoment, convertMomentToUnix } from 'Shared/utils/DateTime.utils';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useOrganization } from 'Shared/utils/hooks/use-organization';

// Components
import CharmaLegacySunsetModal from './CharmaLegacySunsetModal';

const CharmaLegacySunsetModalForcedExperience = () => {
  const { pathname } = useLocation();
  const { isLoggedIn, user, getFlag, updateFlag } = useCurrentUser();
  const { isPiOrganization } = useOrganization();
  const { featureFlagEnableCharmaSunsetMessaging } = useFlags();

  const flag = 'has_acknowledged_sunset_modal';
  const hasAcknowledged = getFlag({ flag });

  const handleDismissModal = () => {
    updateFlag({ flag, value: convertMomentToUnix(getCurrentMoment()) });
  };

  const isOnboardingRoute = matchPath(pathname, { path: [PageUrlsConstants.ONBOARDING_WIZARD] });

  // don't show if FF is not enabled
  if (!featureFlagEnableCharmaSunsetMessaging) return null;
  // don't show if not logged in
  if (!isLoggedIn) return null;
  // don't show for existing PI orgs
  if (isPiOrganization) return null;
  // don't show if user is still signing up
  if (isOnboardingRoute) return null;
  // dont' show if they've already acknowledged
  if (hasAcknowledged) return null;
  // don't show if onboarding is not completed
  if (user && !user.onboarding?.completed_at) return null;

  return <CharmaLegacySunsetModal onDismiss={handleDismissModal} />;
};

export default CharmaLegacySunsetModalForcedExperience;
